<button
  type="button"
  class="eventq-detection-bounding-box"
  [class.eventq-detection-bounding-box--motion]="eventType() === 'motion'"
  [class.eventq-detection-bounding-box--human]="eventType() === 'human'"
  [class.eventq-detection-bounding-box--vehicle]="eventType() === 'vehicle'"
  [class.eventq-detection-bounding-box--gun]="eventType() === 'gun'"
  [class.eventq-detection-bounding-box--clickable]="clickable()"
  [class.eventq-detection-bounding-box--animated]="animated()"
  [style]="positionStyle()"
  [attr.aria-label]="resolvedAriaLabel()"
  (click)="onActivate($event)"
>
  <span class="eventq-detection-bounding-box__fill" aria-hidden="true"></span>
  <span class="eventq-detection-bounding-box__icon" aria-hidden="true"></span>
</button>
